import { d as ut } from "./index.es42.js";
import ct from "./index.es43.js";
import Tt from "./index.es44.js";
import yt from "./index.es45.js";
var Ct = e, At = ut, bt = ct, M = Tt, xt = yt, s = 0, i = s++, L = s++, l = s++, P = s++, D = s++, E = s++, Y = s++, f = s++, y = s++, A = s++, b = s++, x = s++, m = s++, I = s++, w = s++, n = s++, U = s++, V = s++, u = s++, B = s++, N = s++, k = s++, G = s++, Q = s++, $ = s++, q = s++, z = s++, c = s++, C = s++, v = s++, H = s++, X = s++, j = s++, Z = s++, J = s++, K = s++, W = s++, tt = s++, et = s++, st = s++, it = s++, _t = s++, at = s++, ht = s++, rt = s++, nt = s++, ot = s++, ft = s++, lt = s++, pt = s++, T = s++, dt = s++, R = s++, g = s++, O = s++, F = 0, S = F++, St = F++, Et = F++;
function a(t) {
  return t === " " || t === `
` || t === "	" || t === "\f" || t === "\r";
}
function h(t, _, r) {
  var o = t.toLowerCase();
  return t === o ? function(d) {
    d === o ? this._state = _ : (this._state = r, this._index--);
  } : function(d) {
    d === o || d === t ? this._state = _ : (this._state = r, this._index--);
  };
}
function p(t, _) {
  var r = t.toLowerCase();
  return function(o) {
    o === r || o === t ? this._state = _ : (this._state = l, this._index--);
  };
}
function e(t, _) {
  this._state = i, this._buffer = "", this._sectionStart = 0, this._index = 0, this._bufferOffset = 0, this._baseState = i, this._special = S, this._cbs = _, this._running = !0, this._ended = !1, this._xmlMode = !!(t && t.xmlMode), this._decodeEntities = !!(t && t.decodeEntities);
}
e.prototype._stateText = function(t) {
  t === "<" ? (this._index > this._sectionStart && this._cbs.ontext(this._getSection()), this._state = L, this._sectionStart = this._index) : this._decodeEntities && this._special === S && t === "&" && (this._index > this._sectionStart && this._cbs.ontext(this._getSection()), this._baseState = i, this._state = T, this._sectionStart = this._index);
};
e.prototype._stateBeforeTagName = function(t) {
  t === "/" ? this._state = D : t === "<" ? (this._cbs.ontext(this._getSection()), this._sectionStart = this._index) : t === ">" || this._special !== S || a(t) ? this._state = i : t === "!" ? (this._state = w, this._sectionStart = this._index + 1) : t === "?" ? (this._state = U, this._sectionStart = this._index + 1) : (this._state = !this._xmlMode && (t === "s" || t === "S") ? H : l, this._sectionStart = this._index);
};
e.prototype._stateInTagName = function(t) {
  (t === "/" || t === ">" || a(t)) && (this._emitToken("onopentagname"), this._state = f, this._index--);
};
e.prototype._stateBeforeCloseingTagName = function(t) {
  a(t) || (t === ">" ? this._state = i : this._special !== S ? t === "s" || t === "S" ? this._state = X : (this._state = i, this._index--) : (this._state = E, this._sectionStart = this._index));
};
e.prototype._stateInCloseingTagName = function(t) {
  (t === ">" || a(t)) && (this._emitToken("onclosetag"), this._state = Y, this._index--);
};
e.prototype._stateAfterCloseingTagName = function(t) {
  t === ">" && (this._state = i, this._sectionStart = this._index + 1);
};
e.prototype._stateBeforeAttributeName = function(t) {
  t === ">" ? (this._cbs.onopentagend(), this._state = i, this._sectionStart = this._index + 1) : t === "/" ? this._state = P : a(t) || (this._state = y, this._sectionStart = this._index);
};
e.prototype._stateInSelfClosingTag = function(t) {
  t === ">" ? (this._cbs.onselfclosingtag(), this._state = i, this._sectionStart = this._index + 1) : a(t) || (this._state = f, this._index--);
};
e.prototype._stateInAttributeName = function(t) {
  (t === "=" || t === "/" || t === ">" || a(t)) && (this._cbs.onattribname(this._getSection()), this._sectionStart = -1, this._state = A, this._index--);
};
e.prototype._stateAfterAttributeName = function(t) {
  t === "=" ? this._state = b : t === "/" || t === ">" ? (this._cbs.onattribend(), this._state = f, this._index--) : a(t) || (this._cbs.onattribend(), this._state = y, this._sectionStart = this._index);
};
e.prototype._stateBeforeAttributeValue = function(t) {
  t === '"' ? (this._state = x, this._sectionStart = this._index + 1) : t === "'" ? (this._state = m, this._sectionStart = this._index + 1) : a(t) || (this._state = I, this._sectionStart = this._index, this._index--);
};
e.prototype._stateInAttributeValueDoubleQuotes = function(t) {
  t === '"' ? (this._emitToken("onattribdata"), this._cbs.onattribend(), this._state = f) : this._decodeEntities && t === "&" && (this._emitToken("onattribdata"), this._baseState = this._state, this._state = T, this._sectionStart = this._index);
};
e.prototype._stateInAttributeValueSingleQuotes = function(t) {
  t === "'" ? (this._emitToken("onattribdata"), this._cbs.onattribend(), this._state = f) : this._decodeEntities && t === "&" && (this._emitToken("onattribdata"), this._baseState = this._state, this._state = T, this._sectionStart = this._index);
};
e.prototype._stateInAttributeValueNoQuotes = function(t) {
  a(t) || t === ">" ? (this._emitToken("onattribdata"), this._cbs.onattribend(), this._state = f, this._index--) : this._decodeEntities && t === "&" && (this._emitToken("onattribdata"), this._baseState = this._state, this._state = T, this._sectionStart = this._index);
};
e.prototype._stateBeforeDeclaration = function(t) {
  this._state = t === "[" ? k : t === "-" ? V : n;
};
e.prototype._stateInDeclaration = function(t) {
  t === ">" && (this._cbs.ondeclaration(this._getSection()), this._state = i, this._sectionStart = this._index + 1);
};
e.prototype._stateInProcessingInstruction = function(t) {
  t === ">" && (this._cbs.onprocessinginstruction(this._getSection()), this._state = i, this._sectionStart = this._index + 1);
};
e.prototype._stateBeforeComment = function(t) {
  t === "-" ? (this._state = u, this._sectionStart = this._index + 1) : this._state = n;
};
e.prototype._stateInComment = function(t) {
  t === "-" && (this._state = B);
};
e.prototype._stateAfterComment1 = function(t) {
  t === "-" ? this._state = N : this._state = u;
};
e.prototype._stateAfterComment2 = function(t) {
  t === ">" ? (this._cbs.oncomment(
    this._buffer.substring(this._sectionStart, this._index - 2)
  ), this._state = i, this._sectionStart = this._index + 1) : t !== "-" && (this._state = u);
};
e.prototype._stateBeforeCdata1 = h(
  "C",
  G,
  n
);
e.prototype._stateBeforeCdata2 = h(
  "D",
  Q,
  n
);
e.prototype._stateBeforeCdata3 = h(
  "A",
  $,
  n
);
e.prototype._stateBeforeCdata4 = h(
  "T",
  q,
  n
);
e.prototype._stateBeforeCdata5 = h(
  "A",
  z,
  n
);
e.prototype._stateBeforeCdata6 = function(t) {
  t === "[" ? (this._state = c, this._sectionStart = this._index + 1) : (this._state = n, this._index--);
};
e.prototype._stateInCdata = function(t) {
  t === "]" && (this._state = C);
};
e.prototype._stateAfterCdata1 = function(t) {
  t === "]" ? this._state = v : this._state = c;
};
e.prototype._stateAfterCdata2 = function(t) {
  t === ">" ? (this._cbs.oncdata(
    this._buffer.substring(this._sectionStart, this._index - 2)
  ), this._state = i, this._sectionStart = this._index + 1) : t !== "]" && (this._state = c);
};
e.prototype._stateBeforeSpecial = function(t) {
  t === "c" || t === "C" ? this._state = j : t === "t" || t === "T" ? this._state = at : (this._state = l, this._index--);
};
e.prototype._stateBeforeSpecialEnd = function(t) {
  this._special === St && (t === "c" || t === "C") ? this._state = tt : this._special === Et && (t === "t" || t === "T") ? this._state = ot : this._state = i;
};
e.prototype._stateBeforeScript1 = p(
  "R",
  Z
);
e.prototype._stateBeforeScript2 = p(
  "I",
  J
);
e.prototype._stateBeforeScript3 = p(
  "P",
  K
);
e.prototype._stateBeforeScript4 = p(
  "T",
  W
);
e.prototype._stateBeforeScript5 = function(t) {
  (t === "/" || t === ">" || a(t)) && (this._special = St), this._state = l, this._index--;
};
e.prototype._stateAfterScript1 = h("R", et, i);
e.prototype._stateAfterScript2 = h("I", st, i);
e.prototype._stateAfterScript3 = h("P", it, i);
e.prototype._stateAfterScript4 = h("T", _t, i);
e.prototype._stateAfterScript5 = function(t) {
  t === ">" || a(t) ? (this._special = S, this._state = E, this._sectionStart = this._index - 6, this._index--) : this._state = i;
};
e.prototype._stateBeforeStyle1 = p(
  "Y",
  ht
);
e.prototype._stateBeforeStyle2 = p(
  "L",
  rt
);
e.prototype._stateBeforeStyle3 = p(
  "E",
  nt
);
e.prototype._stateBeforeStyle4 = function(t) {
  (t === "/" || t === ">" || a(t)) && (this._special = Et), this._state = l, this._index--;
};
e.prototype._stateAfterStyle1 = h("Y", ft, i);
e.prototype._stateAfterStyle2 = h("L", lt, i);
e.prototype._stateAfterStyle3 = h("E", pt, i);
e.prototype._stateAfterStyle4 = function(t) {
  t === ">" || a(t) ? (this._special = S, this._state = E, this._sectionStart = this._index - 5, this._index--) : this._state = i;
};
e.prototype._stateBeforeEntity = h(
  "#",
  dt,
  R
);
e.prototype._stateBeforeNumericEntity = h(
  "X",
  O,
  g
);
e.prototype._parseNamedEntityStrict = function() {
  if (this._sectionStart + 1 < this._index) {
    var t = this._buffer.substring(
      this._sectionStart + 1,
      this._index
    ), _ = this._xmlMode ? xt : bt;
    _.hasOwnProperty(t) && (this._emitPartial(_[t]), this._sectionStart = this._index + 1);
  }
};
e.prototype._parseLegacyEntity = function() {
  var t = this._sectionStart + 1, _ = this._index - t;
  for (_ > 6 && (_ = 6); _ >= 2; ) {
    var r = this._buffer.substr(t, _);
    if (M.hasOwnProperty(r)) {
      this._emitPartial(M[r]), this._sectionStart += _ + 1;
      return;
    } else
      _--;
  }
};
e.prototype._stateInNamedEntity = function(t) {
  t === ";" ? (this._parseNamedEntityStrict(), this._sectionStart + 1 < this._index && !this._xmlMode && this._parseLegacyEntity(), this._state = this._baseState) : (t < "a" || t > "z") && (t < "A" || t > "Z") && (t < "0" || t > "9") && (this._xmlMode || this._sectionStart + 1 === this._index || (this._baseState !== i ? t !== "=" && this._parseNamedEntityStrict() : this._parseLegacyEntity()), this._state = this._baseState, this._index--);
};
e.prototype._decodeNumericEntity = function(t, _) {
  var r = this._sectionStart + t;
  if (r !== this._index) {
    var o = this._buffer.substring(r, this._index), d = parseInt(o, _);
    this._emitPartial(At(d)), this._sectionStart = this._index;
  } else
    this._sectionStart--;
  this._state = this._baseState;
};
e.prototype._stateInNumericEntity = function(t) {
  t === ";" ? (this._decodeNumericEntity(2, 10), this._sectionStart++) : (t < "0" || t > "9") && (this._xmlMode ? this._state = this._baseState : this._decodeNumericEntity(2, 10), this._index--);
};
e.prototype._stateInHexEntity = function(t) {
  t === ";" ? (this._decodeNumericEntity(3, 16), this._sectionStart++) : (t < "a" || t > "f") && (t < "A" || t > "F") && (t < "0" || t > "9") && (this._xmlMode ? this._state = this._baseState : this._decodeNumericEntity(3, 16), this._index--);
};
e.prototype._cleanup = function() {
  this._sectionStart < 0 ? (this._buffer = "", this._bufferOffset += this._index, this._index = 0) : this._running && (this._state === i ? (this._sectionStart !== this._index && this._cbs.ontext(this._buffer.substr(this._sectionStart)), this._buffer = "", this._bufferOffset += this._index, this._index = 0) : this._sectionStart === this._index ? (this._buffer = "", this._bufferOffset += this._index, this._index = 0) : (this._buffer = this._buffer.substr(this._sectionStart), this._index -= this._sectionStart, this._bufferOffset += this._sectionStart), this._sectionStart = 0);
};
e.prototype.write = function(t) {
  this._ended && this._cbs.onerror(Error(".write() after done!")), this._buffer += t, this._parse();
};
e.prototype._parse = function() {
  for (; this._index < this._buffer.length && this._running; ) {
    var t = this._buffer.charAt(this._index);
    this._state === i ? this._stateText(t) : this._state === L ? this._stateBeforeTagName(t) : this._state === l ? this._stateInTagName(t) : this._state === D ? this._stateBeforeCloseingTagName(t) : this._state === E ? this._stateInCloseingTagName(t) : this._state === Y ? this._stateAfterCloseingTagName(t) : this._state === P ? this._stateInSelfClosingTag(t) : this._state === f ? this._stateBeforeAttributeName(t) : this._state === y ? this._stateInAttributeName(t) : this._state === A ? this._stateAfterAttributeName(t) : this._state === b ? this._stateBeforeAttributeValue(t) : this._state === x ? this._stateInAttributeValueDoubleQuotes(t) : this._state === m ? this._stateInAttributeValueSingleQuotes(t) : this._state === I ? this._stateInAttributeValueNoQuotes(t) : this._state === w ? this._stateBeforeDeclaration(t) : this._state === n ? this._stateInDeclaration(t) : this._state === U ? this._stateInProcessingInstruction(t) : this._state === V ? this._stateBeforeComment(t) : this._state === u ? this._stateInComment(t) : this._state === B ? this._stateAfterComment1(t) : this._state === N ? this._stateAfterComment2(t) : this._state === k ? this._stateBeforeCdata1(t) : this._state === G ? this._stateBeforeCdata2(t) : this._state === Q ? this._stateBeforeCdata3(t) : this._state === $ ? this._stateBeforeCdata4(t) : this._state === q ? this._stateBeforeCdata5(t) : this._state === z ? this._stateBeforeCdata6(t) : this._state === c ? this._stateInCdata(t) : this._state === C ? this._stateAfterCdata1(t) : this._state === v ? this._stateAfterCdata2(t) : this._state === H ? this._stateBeforeSpecial(t) : this._state === X ? this._stateBeforeSpecialEnd(t) : this._state === j ? this._stateBeforeScript1(t) : this._state === Z ? this._stateBeforeScript2(t) : this._state === J ? this._stateBeforeScript3(t) : this._state === K ? this._stateBeforeScript4(t) : this._state === W ? this._stateBeforeScript5(t) : this._state === tt ? this._stateAfterScript1(t) : this._state === et ? this._stateAfterScript2(t) : this._state === st ? this._stateAfterScript3(t) : this._state === it ? this._stateAfterScript4(t) : this._state === _t ? this._stateAfterScript5(t) : this._state === at ? this._stateBeforeStyle1(t) : this._state === ht ? this._stateBeforeStyle2(t) : this._state === rt ? this._stateBeforeStyle3(t) : this._state === nt ? this._stateBeforeStyle4(t) : this._state === ot ? this._stateAfterStyle1(t) : this._state === ft ? this._stateAfterStyle2(t) : this._state === lt ? this._stateAfterStyle3(t) : this._state === pt ? this._stateAfterStyle4(t) : this._state === T ? this._stateBeforeEntity(t) : this._state === dt ? this._stateBeforeNumericEntity(t) : this._state === R ? this._stateInNamedEntity(t) : this._state === g ? this._stateInNumericEntity(t) : this._state === O ? this._stateInHexEntity(t) : this._cbs.onerror(Error("unknown _state"), this._state), this._index++;
  }
  this._cleanup();
};
e.prototype.pause = function() {
  this._running = !1;
};
e.prototype.resume = function() {
  this._running = !0, this._index < this._buffer.length && this._parse(), this._ended && this._finish();
};
e.prototype.end = function(t) {
  this._ended && this._cbs.onerror(Error(".end() after done!")), t && this.write(t), this._ended = !0, this._running && this._finish();
};
e.prototype._finish = function() {
  this._sectionStart < this._index && this._handleTrailingData(), this._cbs.onend();
};
e.prototype._handleTrailingData = function() {
  var t = this._buffer.substr(this._sectionStart);
  this._state === c || this._state === C || this._state === v ? this._cbs.oncdata(t) : this._state === u || this._state === B || this._state === N ? this._cbs.oncomment(t) : this._state === R && !this._xmlMode ? (this._parseLegacyEntity(), this._sectionStart < this._index && (this._state = this._baseState, this._handleTrailingData())) : this._state === g && !this._xmlMode ? (this._decodeNumericEntity(2, 10), this._sectionStart < this._index && (this._state = this._baseState, this._handleTrailingData())) : this._state === O && !this._xmlMode ? (this._decodeNumericEntity(3, 16), this._sectionStart < this._index && (this._state = this._baseState, this._handleTrailingData())) : this._state !== l && this._state !== f && this._state !== b && this._state !== A && this._state !== y && this._state !== m && this._state !== x && this._state !== I && this._state !== E && this._cbs.ontext(t);
};
e.prototype.reset = function() {
  e.call(
    this,
    { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
    this._cbs
  );
};
e.prototype.getAbsoluteIndex = function() {
  return this._bufferOffset + this._index;
};
e.prototype._getSection = function() {
  return this._buffer.substring(this._sectionStart, this._index);
};
e.prototype._emitToken = function(t) {
  this._cbs[t](this._getSection()), this._sectionStart = -1;
};
e.prototype._emitPartial = function(t) {
  this._baseState !== i ? this._cbs.onattribdata(t) : this._cbs.ontext(t);
};
export {
  Ct as T
};
//# sourceMappingURL=index.es25.js.map
